// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"jb_a bhu_vr bhu_iv bhu_wf bhu_i bhu_j bhu_q bhu_un bhu_en bhu_ri bhu_rj bhu_cx","CommentsButton__icon":"jb_b bhu_re"};